export default __webpack_public_path__ + "static/media/size_chart_brand.1d3e0750.png";